import { render, staticRenderFns } from "./HelpControls.vue?vue&type=template&id=60e7235c&scoped=true&"
import script from "./HelpControls.vue?vue&type=script&lang=ts&"
export * from "./HelpControls.vue?vue&type=script&lang=ts&"
import style0 from "./HelpControls.vue?vue&type=style&index=0&id=60e7235c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e7235c",
  null
  
)

export default component.exports